import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import i18n from '../i18n';
import { compose } from 'redux';
import { connect } from 'react-redux';
import SitesActions from '../redux/SitesRedux';
import { withStyles } from '@material-ui/styles';
import withWidth from '@material-ui/core/withWidth';
import clsx from 'clsx';
import { Colors, StyledComponents, Metrics } from '../themes';
import cloneDeep from 'lodash/cloneDeep';
import Header from '../components/header/Header';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Table from '../components/common/Table';
import SiteDetails from '../components/doorsAndLocationsElements/SiteDetails';
import AlertDialog from '../components/common/AlertDialog';
import SnackbarNotification from '../components/common/SnackbarNotification';
import Modal from '../components/common/Modal';
import AddDoorsModal from '../components/accessLevelsElements/AddDoorsModal';

const { MainContentContainer } = StyledComponents;

const styles = (theme) => ({
  gridContainer: {
    [theme.breakpoints.up('xl')]: {
      maxWidth: Metrics.contentGridMaxWidthXl.general,
    },
  },
  paper: {
    textAlign: 'center',
    background: Colors.hoverGrey,
    color: Colors.white,
  },
  listWidget: {},
  detailsWidget: {
    maxWidth: 975,
  },
});

class DoorsAndLocations extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // snackbar
      isSnackbarNotificationOpen: false,
      snackbarVariant: 'warning',
      snackbarMessage: '',
      // alert confirm dialog
      isAlertDialogOpen: false,
      alertTitle: '',
      alertContentText: '',
      alertConfirmAction: null,
      isSaveAlert: false,
      // sites page params
      sitesItemsPerPage: 10,
      sitesPageNumber: 0,
      sitesSearchValue: null,
      sitesSortDirection: 'ASC',
      // sites details
      isNewSite: false,
      siteId: null,
      addressId: null,
      firstName: '',
      lastName: '',
      street1: '',
      street1no: '',
      zip: '',
      city: '',
      // controller details
      hideDetails: true,
      controllerId: null,
      controllerName: '',
      tempControllerName: '',
      checkedDoors: [],
      // add doors modal
      isDoorsModalOpen: false,
      doorsItemsPerPage: 10,
      doorsPageNumber: 0,
      doorsSearchValue: null,
      doorsSortBy: 'controllerUid',
      doorsSortDirection: 'ASC',
    };
  }

  componentDidMount() {
    if (this.props.customerId) {
      this.sendGetSitesRequest();
    }
  }

  componentWillUnmount() {
    this.props.resetSites();
    this.props.resetCustomerControllers();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.customerId !== this.props.customerId) {
      this.props.resetSites();
      this.props.resetCustomerControllers();
      this.resetSiteFormFields();
      if (this.props.customerId) {
        this.sendGetSitesRequest();
      }
    }
    if (prevProps.sitesIsLoading && !this.props.sitesIsLoading) {
      if (this.props.sitesSuccessMessage) {
        this.setState({
          isSnackbarNotificationOpen: true,
          snackbarVariant: 'success',
          snackbarMessage: this.props.sitesSuccessMessage,
        });
      }
      if (this.props.sitesErrorMessage) {
        this.setState({
          isSnackbarNotificationOpen: true,
          snackbarVariant: 'error',
          snackbarMessage: this.props.sitesErrorMessage,
        });
      }
      if (prevProps.createdId !== this.props.createdId) {
        this.setState({ siteId: this.props.createdId, addressId: this.props.createdAddressId, isNewSite: false });
      }
    }
  }

  //common methods

  handleChangeFormValues = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  // sites list table methods

  sendGetSitesRequest() {
    const pageParams = {
      items: this.state.sitesItemsPerPage,
      page: this.state.sitesPageNumber,
      value: this.state.sitesSearchValue,
      sort: this.state.sitesSortDirection,
    };
    this.props.getSites(this.props.customerId, pageParams);
  }

  changeSitesItemsPerPage = (sitesItemsPerPage) => {
    this.setState({ sitesItemsPerPage, sitesPageNumber: 0 }, () => this.sendGetSitesRequest());
  };

  changeSitesPage = (sitesPageNumber) => {
    this.setState({ sitesPageNumber }, () => this.sendGetSitesRequest());
  };

  handleSearchSite = (sitesSearchValue) => {
    this.setState({ sitesSearchValue, sitesPageNumber: 0 }, () => this.sendGetSitesRequest());
    this.resetSiteFormFields();
  };

  handleSortSite = (sitesSortBy, sitesSortDirection) => {
    this.setState({ sitesSortDirection, sitesPageNumber: 0 }, () => this.sendGetSitesRequest());
    this.resetSiteFormFields();
  };

  handleSearchSiteKeyPress = (event, value) => {
    if (event.key === 'Enter') {
      this.handleSearchSite(value);
    }
  };

  handleSiteDetailsFormKeyPress = () => {
    console.log('handleSiteDetailsFormKeyPress not implemented');
  };

  selectSite = (site) => {
    this.resetSiteFormFields();
    let siteId = site.siteId ? site.siteId : null,
      addressId = site.address && site.address.addressId ? site.address.addressId : '',
      firstName = site.address && site.address.firstName ? site.address.firstName : '',
      lastName = site.address && site.address.lastName ? site.address.lastName : '',
      street1 = site.address && site.address.street1 ? site.address.street1 : '',
      street1no = site.address && site.address.street1no ? site.address.street1no : '',
      zip = site.address && site.address.zip ? site.address.zip : '',
      city = site.address && site.address.city ? site.address.city : '';
    this.setState(
      { hideDetails: false, isNewSite: false, siteId, addressId, firstName, lastName, street1, street1no, zip, city },
      () => this.sendGetControllersRequest()
    );
  };

  // site details form methods

  resetSiteFormFields = () => {
    this.setState({
      siteId: null,
      addressId: null,
      firstName: '',
      lastName: '',
      street1: '',
      street1no: '',
      zip: '',
      city: '',
      controllerId: null,
      controllerName: '',
      tempControllerName: '',
    });
    this.props.resetControllers();
  };

  handleAddSite = () => {
    this.resetSiteFormFields();
    this.setState({ hideDetails: false, sitesSearchValue: null, isNewSite: true });
  };

  handleSaveSite = () => {
    const { siteId, addressId, firstName, lastName, street1, street1no, zip, city } = this.state;
    const siteInfos = {
      address: { firstName, lastName, street1, street1no, zip, city },
      customerId: this.props.customerId,
      statusId: 1,
    };
    const editSiteInfos = { ...siteInfos, siteId, address: { ...siteInfos.address, addressId } };
    const pageParams = {
      items: this.state.sitesItemsPerPage,
      page: this.state.sitesPageNumber,
      value: this.state.sitesSearchValue,
      sort: this.state.sitesSortDirection,
    };
    this.state.isNewSite
      ? this.props.createSite(siteInfos, this.props.customerId, pageParams)
      : this.props.editSite(editSiteInfos, this.props.customerId, pageParams);
  };

  openDeleteSiteAlert = () => {
    const siteName = this.state.lastName ? `${this.state.firstName} ${this.state.lastName}` : this.state.firstName;
    this.setState({
      isAlertDialogOpen: true,
      isSaveAlert: false,
      alertTitle: i18n.t('alert.deleteSiteTitle'),
      alertContentText: i18n.t('siteManager_confirmDeleteSite', {
        siteName,
      }),
      alertConfirmAction: this.deleteSite,
    });
  };

  deleteSite = () => {
    const pageParams = {
      items: this.state.sitesItemsPerPage,
      page: this.state.sitesPageNumber,
      value: this.state.sitesSearchValue,
      sort: this.state.sitesSortDirection,
    };
    this.props.deleteSite(this.state.siteId, this.props.customerId, pageParams);
    this.resetSiteFormFields();
    this.setState({ isAlertDialogOpen: false, hideDetails: true });
  };

  handleSiteDetailsFormKeyPress = (event) => {
    if (event.key === 'Enter') {
      if (!this.state.sitesSearchValue) {
        return this.handleSaveSite();
      }
    }
  };

  // controllers methods

  sendGetControllersRequest() {
    this.props.getSiteControllers(this.state.siteId);
  }

  openDeleteControllerAlert = (controller) => {
    this.selectController(controller);
    this.setState({
      isAlertDialogOpen: true,
      alertTitle: i18n.t('alert.deleteDoorTitle'),
      alertContentText: `${i18n.t('siteManager_confirmDeleteController', {
        name: controller.name,
      })} ${i18n.t('siteManager_confirmDeleteControllerAccessLevels')}`,
      alertConfirmAction: () => this.deleteSiteController(controller.controllerId),
    });
  };

  deleteSiteController = (controllerId) => {
    const data = [controllerId];
    this.props.deleteSiteController(this.state.siteId, data);
    this.setState({ isAlertDialogOpen: false });
  };

  selectController = (controller) => {
    const { name, controllerId } = controller;
    this.setState({ controllerName: name, tempControllerName: name, controllerId });
  };

  openSaveControllerChangesAlert = () => {
    if (this.state.controllerName !== this.state.tempControllerName) {
      this.setState({
        isAlertDialogOpen: true,
        alertTitle: i18n.t('alert.saveControllerNameTitle'),
        alertContentText: i18n.t('alert.saveControllerNameContent'),
        alertConfirmAction: this.saveControllerChanges,
        isSaveAlert: true,
      });
    }
  };

  discardControllerChanges = () => {
    this.setState((prevState) => ({
      isAlertDialogOpen: false,
      isSaveAlert: false,
      tempControllerName: prevState.controllerName,
    }));
  };

  saveControllerChanges = () => {
    const controllerInfos = {
      controllerName: this.state.tempControllerName,
      customerId: this.props.customerId,
      siteId: this.state.siteId,
    };
    this.props.editSiteController(this.state.controllerId, controllerInfos, this.state.siteId);
    this.setState((prevState) => ({
      isAlertDialogOpen: false,
      isSaveAlert: false,
      controllerName: prevState.tempControllerName,
    }));
  };

  // Doors modal methods

  handleAddDoor = () => {
    console.log('handleAddDoor:');
    this.sendGetDoorsRequest();
    this.setState({ doorsSearchValue: null, isDoorsModalOpen: true });
  };

  sendGetDoorsRequest() {
    const pageParams = {
      items: this.state.doorsItemsPerPage,
      page: this.state.doorsPageNumber,
      value: this.state.doorsSearchValue,
      sortBy: this.state.doorsSortBy,
      sortDirection: this.state.doorsSortDirection,
    };
    this.props.getSiteAvailableControllers(pageParams, this.props.customerId);
  }

  changeDoorsItemsPerPage = (doorsItemsPerPage) => {
    this.setState({ doorsItemsPerPage, doorsPageNumber: 0 }, () => this.sendGetDoorsRequest());
  };

  changeDoorsPage = (doorsPageNumber) => {
    this.setState({ doorsPageNumber }, () => this.sendGetDoorsRequest());
  };

  handleSearchDoor = (doorsSearchValue) => {
    this.setState({ doorsSearchValue, doorsPageNumber: 0 }, () => this.sendGetDoorsRequest());
  };

  handleSearchDoorKeyPress = (event, value) => {
    if (event.key === 'Enter') {
      this.handleSearchDoor(value);
    }
  };

  handleSortDoor = (doorsSortBy, doorsSortDirection) => {
    this.setState({ doorsSortBy, doorsSortDirection, doorsPageNumber: 0 }, () => this.sendGetDoorsRequest());
  };

  selectDoor = (door) => {
    const previousDoors = this.state.checkedDoors;
    //check if the door was present in checkedDoors
    const selectedIndex = previousDoors.findIndex((item) => item.controllerId === door.controllerId);
    let newCheckedDoors = [];

    if (selectedIndex === -1) {
      // if not found, add it
      newCheckedDoors = newCheckedDoors.concat(previousDoors, door);
    } else if (selectedIndex === 0) {
      // if first item, remove it
      newCheckedDoors = newCheckedDoors.concat(previousDoors.slice(1));
    } else if (selectedIndex === previousDoors.length - 1) {
      // if last item, remove it
      newCheckedDoors = newCheckedDoors.concat(previousDoors.slice(0, -1));
    } else if (selectedIndex > 0) {
      // if between first and last, remove it
      newCheckedDoors = newCheckedDoors.concat(
        previousDoors.slice(0, selectedIndex),
        previousDoors.slice(selectedIndex + 1)
      );
    }
    this.setState({ checkedDoors: newCheckedDoors });
  };

  closeDoorsModalWithoutSave = () => {
    this.setState({ checkedDoors: [], isDoorsModalOpen: false });
  };

  saveDoors = () => {
    const { customerId, distributorId } = this.props;
    const data = this.state.checkedDoors.map(({ controllerId }) => ({ controllerId }));
    this.props.addControllerToSite(this.state.siteId, data, customerId, distributorId);
    this.setState({ isDoorsModalOpen: false, checkedDoors: [] });
  };

  render() {
    const { t, classes, width } = this.props;
    const isLarge = width === 'lg' || width === 'xl';
    const sitesData = cloneDeep(this.props.sites); //this is necessary for table to work
    const flattenedSitesData = sitesData
      ? sitesData.map((site) => ({
          ...site,
          name: `${site.address.firstName} ${site.address.lastName}`,
        }))
      : null;
    const controllersInitialData = cloneDeep(this.props.controllers);
    const controllersData = controllersInitialData
      ? controllersInitialData.map((controller) => ({
          ...controller,
          nameDescription: `${controller.name ? controller.name : ''} ${
            controller.description ? controller.description : ''
          }`,
        }))
      : null;
    return (
      <MainContentContainer className={classes.MainContentContainer}>
        <AlertDialog
          open={this.state.isAlertDialogOpen}
          handleClose={() => this.setState({ isAlertDialogOpen: false })}
          title={this.state.alertTitle}
          contentText={this.state.alertContentText}
          cancelButtonText={t(this.state.isSaveAlert ? 'Global_discard' : 'Global_cancel')}
          confirmButtonText={t(this.state.isSaveAlert ? 'Global_save' : 'Global_delete')}
          onConfirm={this.state.alertConfirmAction}
          {...(this.state.isSaveAlert && {
            leftButtonRed: true,
            rightButtonBlue: true,
            leftButtonAction: this.discardControllerChanges,
          })}
        />
        <SnackbarNotification
          variant={this.state.snackbarVariant}
          open={this.state.isSnackbarNotificationOpen}
          message={this.state.snackbarMessage}
          close={() => this.setState({ isSnackbarNotificationOpen: false })}
        />
        <Modal
          open={this.state.isDoorsModalOpen}
          handleClose={this.closeDoorsModalWithoutSave}
          Content={AddDoorsModal}
          onClickSave={this.saveDoors}
          // search access levels table props
          checkboxColumn="start"
          data={cloneDeep(this.props.siteAvailableControllers)}
          noDataText={t('sites.noDoor')}
          handleClick={(door) => this.selectDoor(door)}
          columns={[
            { title: t('siteManager_controllers_col1'), field: 'controllerUid' },
            { title: t('siteManager_controllers_col2'), field: 'name' },
          ]}
          handleSearch={this.handleSearchDoor}
          sortBy={this.state.doorsSortBy}
          sortDirection={this.state.doorsSortDirection}
          handleSort={this.handleSortDoor}
          activeRowField={'controllerId'}
          checkedArray={this.state.checkedDoors}
          searchPlaceholder={t('doorControlManager_addControllersModal_searchControllers')}
          itemsPerPage={this.state.doorsItemsPerPage}
          changeItemsPerPage={this.changeDoorsItemsPerPage}
          totalElements={this.props.siteAvailableControllersTotal}
          page={this.state.doorsPageNumber}
          changePage={this.changeDoorsPage}
          onKeyPress={this.handleSearchDoorKeyPress}
          // rows per page select props
          selectData={[5, 10, 20]}
          selectLabel={t('table.showPerPage')}
          selectValue={this.state.doorsItemsPerPage}
          onSelect={this.changeDoorsItemsPerPage}
          selectWidth={90}
        />
        <Header />
        <Grid container className={classes.gridContainer} spacing={isLarge ? 6 : 5}>
          <Grid item xs={12} md={6} xl={5}>
            <Paper className={clsx(classes.paper, classes.listWidget)}>
              <Table
                data={flattenedSitesData}
                noDataText={t('controllerManager_noSite')}
                handleClick={(value) => this.selectSite(value)}
                columns={[{ title: t('common.name'), field: 'name', id: 'name' }]}
                activeRowValue={this.state.siteId}
                activeRowField={'siteId'}
                handleSearch={this.handleSearchSite}
                sortBy={'name'}
                sortDirection={this.state.sitesSortDirection}
                handleSort={this.handleSortSite}
                searchPlaceholder={t('sites.searchSite')}
                itemsPerPage={this.state.sitesItemsPerPage}
                changeItemsPerPage={this.changeSitesItemsPerPage}
                totalElements={this.props.sitesTotalElements}
                page={this.state.sitesPageNumber}
                changePage={this.changeSitesPage}
                onKeyPress={this.handleSearchSiteKeyPress}
                // rows per page select props
                selectData={[5, 10, 20]}
                selectLabel={t('table.showPerPage')}
                selectValue={this.state.sitesItemsPerPage}
                onSelect={this.changeSitesItemsPerPage}
                selectWidth={90}
              />
            </Paper>
          </Grid>
          <Grid item xs={12} md={6} xl={7}>
            <Paper className={clsx(classes.paper, classes.detailsWidget)}>
              <SiteDetails
                copyable
                // buttons
                add1ButtonText={t('siteManager_addNewSite')}
                add2ButtonText={t('siteManager_addControllersToSite')}
                onDeleteButtonClick={this.openDeleteSiteAlert}
                onAdd1ButtonClick={this.handleAddSite}
                onAdd2ButtonClick={this.handleAddDoor}
                onSaveButtonClick={this.handleSaveSite}
                isDeleteButtonDisabled={!this.state.siteId || this.state.isNewSite}
                add2ButtonDisabled={this.state.isNewSite}
                saveButtonDisabled={!this.state.siteId && !this.state.isNewSite}
                // site details form
                onKeyPressFormSubmit={this.handleSiteDetailsFormKeyPress}
                bodyComponent="SiteDetails"
                onChange={this.handleChangeFormValues}
                hideDetails={this.state.hideDetails}
                siteId={this.state.siteId}
                firstName={this.state.firstName}
                lastName={this.state.lastName}
                street={this.state.street}
                street1no={this.state.street1no}
                zip={this.state.zip}
                city={this.state.city}
                // details table
                tableTitle={t('siteManager_controllers_header')}
                data={controllersData}
                columns={[
                  { title: t('siteManager_controllers_col1'), field: 'controllerUid' },
                  { title: t('siteManager_controllers_col2'), field: 'nameDescription', type: 'textInput' },
                ]}
                activeRowValue={this.state.controllerId}
                activeRowField={'controllerId'}
                noDataText={t('sites.noDoor')}
                handleClick={(controller) => this.selectController(controller)}
                // editableColumn={'nameDescription'}
                editableValue={this.state.tempControllerName}
                handleEditColumn={(event) => this.setState({ tempControllerName: event.target.value })}
                handleEditBlur={this.openSaveControllerChangesAlert}
                deleteColumn
                handleDeleteButtonClick={(door) => this.openDeleteControllerAlert(door)}
                noHeader
                noFooter
              />
            </Paper>
          </Grid>
        </Grid>
      </MainContentContainer>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    customerId: state.auth.customerId,
    distributorId: state.auth.distributorId,
    sites: state.sites.sites,
    sitesTotalElements: state.sites.totalElements,
    createdId: state.sites.createdId,
    createdAddressId: state.sites.createdAddressId,
    sitesIsLoading: state.sites.isLoading,
    sitesSuccessMessage: state.sites.successMessage,
    sitesErrorMessage: state.sites.errorMessage,
    controllers: state.sites.controllers,
    siteAvailableControllers: state.sites.siteAvailableControllers,
    siteAvailableControllersTotal: state.sites.siteAvailableControllersTotal,
  };
};

const mapDispatchToProps = (dispatch) => ({
  // sites
  getSites: (customerId, pageParams) => dispatch(SitesActions.getSitesRequest(customerId, pageParams)),
  createSite: (siteInfos, customerId, pageParams) =>
    dispatch(SitesActions.createSiteRequest(siteInfos, customerId, pageParams)),
  editSite: (siteInfos, customerId, pageParams) =>
    dispatch(SitesActions.editSiteRequest(siteInfos, customerId, pageParams)),
  deleteSite: (siteId, customerId, pageParams) =>
    dispatch(SitesActions.deleteSiteRequest(siteId, customerId, pageParams)),
  getSiteControllers: (siteId) => dispatch(SitesActions.getSiteControllersRequest(siteId)),
  editSiteController: (controllerId, controllerInfos, siteId) =>
    dispatch(SitesActions.editSiteControllerRequest(controllerId, controllerInfos, siteId)),
  deleteSiteController: (siteId, data) => dispatch(SitesActions.deleteSiteControllerRequest(siteId, data)),
  getSiteAvailableControllers: (pageParams, customerId) =>
    dispatch(SitesActions.getSiteAvailableControllersRequest(pageParams, customerId)),
  addControllerToSite: (siteId, data, customerId, distributorId) =>
    dispatch(SitesActions.addControllerToSiteRequest(siteId, data, customerId, distributorId)),
  resetSites: () => dispatch(SitesActions.resetSites()),
  resetControllers: () => dispatch(SitesActions.resetControllers()),
  resetCustomerControllers: () => dispatch(SitesActions.resetCustomerControllers()),
});

export default compose(
  withTranslation(),
  withStyles(styles),
  withWidth(),
  connect(mapStateToProps, mapDispatchToProps)
)(DoorsAndLocations);
